// Static template config for the Data Import landing page (worksheets, copy, step order).
// Submission data (in-progress list, past submissions) comes from SubmissionsListSlice instead.

import { TemplateType } from "services/DataImportService";

// GetSelfServeDataImportWorksheetTypes filters by the BE's numeric template type ID and returns
// an empty list without it — the FE's string enum maps to these fixed IDs.
export const TEMPLATE_TYPE_IDS: Record<TemplateType, number> = {
  [TemplateType.StaticData]: 1,
  [TemplateType.BalanceImport]: 2,
};

export type TemplateSubmissionCardData = {
  step: number;
  title: string;
  description: string;
  estTime: string;
  worksheets: string[];
  locked: boolean;
  downloadUrl?: string;
};

export const staticDataCard: TemplateSubmissionCardData = {
  step: 1,
  title: "Static Data Import",
  description:
    "Your master reference data — developments, properties, clients, suppliers and billing schedules. This must be imported before your balances.",
  estTime: "TBC by CPL",
  locked: false,
  // Data worksheets in the static data template workbook.
  worksheets: [
    "Charge Dates",
    "Nominal Codes",
    "Nominal Bank Code",
    "Offices",
    "Fiscal Period",
    "Unit Types",
    "LegalEntities",
    "Freeholders",
    "Developments",
    "Blocks",
    "Properties",
    "Clients",
    "Apportionments",
    "Fund Schedules",
    "Fund Headers",
    "FundSchedule Billing Period",
    "Job Types",
    "PL Accounts",
  ],
};

export const balanceCard: TemplateSubmissionCardData = {
  step: 2,
  title: "Balance Import",
  description:
    "Your financial cut-over balances from your previous system. These reference the entities you define in Static Data, so Step 1 must be completed first.",
  estTime: "TBC by CPL",
  // Overridden at runtime in DataImportLanding.
  locked: false,
  // Worksheets in the balance import template workbook.
  worksheets: [
    "PurchaseLedger-Opening Balance",
    "Current Property Owner Balance",
    "Freeholder Opening Balances",
    "Income Opening Balance",
    "Expenditure Opening Balance",
    "Balance Sheet Opening Balance",
  ],
};

export function templateTypeLabel(templateType: TemplateType | undefined): string {
  return templateType === TemplateType.StaticData ? staticDataCard.title : balanceCard.title;
}

export function worksheetsForTemplate(templateType: TemplateType | undefined): string[] {
  return templateType === TemplateType.StaticData ? staticDataCard.worksheets : balanceCard.worksheets;
}
